import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import {
  BaseCoreState,
  CustomerInquiryOfferListItemResponse,
  CustomerOfferResponse,
  DocumentListItemResponse,
  BaseDocumentsService,
} from 'base';

@Component({
  selector: 'base-customer-offer-documents-tab',
  templateUrl: 'base-customer-offer-documents-tab.component.html',
})
export class BaseCustomerOfferDocumentsTabComponent implements OnInit, OnDestroy {
  @Input() offer: (CustomerInquiryOfferListItemResponse & { order?: number }) | CustomerOfferResponse;
  documentList: Array<DocumentListItemResponse & { categoryLabel?: string }> = [];
  documentCategories: { value: number; label: string }[] = [];

  private destroy$ = new Subject<boolean>();

  constructor(private store: Store<BaseCoreState>, private baseDocumentsService: BaseDocumentsService) {}

  ngOnInit() {
    this.getDocumentsCategories();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private getDocumentsCategories() {
    this.baseDocumentsService
      .getDocumentCategories('offer')
      .pipe(takeUntil(this.destroy$))
      .subscribe((categories) => {
        this.documentCategories = categories;

        this.documentList = this.offer.documents.map((document) => {
          return {
            ...document,
            categoryLabel: this.documentCategories.find((category) => category.value === document.category)?.label,
          };
        });
      });
  }
}
